import { InternalDatabaseService } from '@stockcare-storage/internal/internal-database.service';
import { Pack } from './pack';
import { Injectable } from '@angular/core';
import { SettingsService } from '@stockcare-services/settings-service/settings.service';
import { DeviceService } from '@stockcare-services/devices-service/devices.service';
import { Settings } from '@stockcare-helpers/settings';

@Injectable({
  providedIn: 'root',
})
export class PackStorageService {
  readonly table: string;
  readonly barcodeIndex: string;
  readonly idIndex: string;
  enableLocalDB: boolean;
  packs: Pack[] = [];

  constructor(
    private internalDatabaseService: InternalDatabaseService,
    private readonly settingsService: SettingsService,
    private readonly deviceService: DeviceService
  ) {
    const table = Pack.getTableDefinition();
    this.table = table.TableName;
    this.barcodeIndex = table.Indexes[0].Name;
    this.idIndex = table.Indexes[1].Name;
    this.getSettings();
  }

  async addPacks(packs: Pack[]) {
    if (this.enableLocalDB) {
      await this.internalDatabaseService.addRange<Pack>(this.table, packs);
    } else {
      this.packs = [...packs];
    }
  }

  async getPacks(): Promise<Pack[]> {
    if (this.enableLocalDB) {
      return await this.internalDatabaseService.getAll<Pack>(this.table);
    } else {
      return this.packs;
    }
  }

  async getPackByBarcodeIndex(barcode) {
    if (this.enableLocalDB) {
      return await this.internalDatabaseService.getByIndex<Pack>(this.table, this.barcodeIndex, barcode);
    } else {
      return this.packs.filter((x) => x.barcode === barcode);
    }
  }

  async getPackByIdIndex(id) {
    if (this.enableLocalDB) {
      return await this.internalDatabaseService.getByIndex<Pack>(this.table, this.idIndex, id);
    } else {
      return this.packs.find((pack) => pack.id === id);
    }
  }

  async updatePack(pack: Pack): Promise<void> {
    if (this.enableLocalDB) {
      await this.internalDatabaseService.update(this.table, pack);
    } else {
      return new Promise<void>((resolve) => {
        this.packs = this.packs.filter((pack) => pack.barcode !== pack.barcode);

        this.packs.push(pack);
        resolve();
      });
    }
  }

  async deleteAll() {
    if (this.enableLocalDB) {
      await this.internalDatabaseService.deleteAll(this.table);
    } else {
      this.packs = [];
    }
  }

  getSettings() {
    const theatreDevice = this.deviceService.isTheaterDevice();
    if (theatreDevice) {
      this.enableLocalDB = this.settingsService.getBooleanSetting(Settings.ENABLE_INDEXED_DB);
    } else {
      this.enableLocalDB = true;
    }
  }
}
